import React from "react";
import promoviendoCapital from "../../assets/images/logo-proj-una/Promoviendo-capital.jpeg";
import campusPerezZeledon from "../../assets/images/logo-proj-una/CampusPerezZeledón.png";

interface ProjectCreditsProps {
  light?: boolean;
}

const ProjectCredits: React.FC<ProjectCreditsProps> = ({ light = false }) => (
  <section
    aria-labelledby="project-credits-title"
    className={light ? "border-t border-border bg-white px-4 py-6 text-center sm:px-6" : "border-t border-white/20 py-4 text-center"}
  >
    <div className="mx-auto max-w-[960px]">
      <h2
        id="project-credits-title"
        className={`text-base font-semibold ${light ? "text-primary-dark" : "text-white"}`}
      >
        Desarrollado por medio de:
      </h2>

      <div className="my-2 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-5">
        <div className="max-w-full rounded-md bg-white p-1">
          <img
            src={promoviendoCapital}
            alt="Promoviendo el Capital Social en Comunidades Rurales de la Región Brunca"
            width={1080}
            height={1080}
            loading="lazy"
            className={`h-auto max-w-full object-contain ${light ? "w-44" : "w-36"}`}
          />
        </div>
        <div className="max-w-full rounded-md bg-white p-2">
          <img
            src={campusPerezZeledon}
            alt="Universidad Nacional, Campus Pérez Zeledón"
            width={868}
            height={548}
            loading="lazy"
            className={`w-auto max-w-full object-contain ${light ? "h-16" : "h-14"}`}
          />
        </div>
      </div>

      <h3 className={`text-sm font-bold ${light ? "text-primary-dark" : "text-white"}`}>Proyecto:</h3>
      <p className={`mx-auto max-w-[800px] leading-relaxed ${light ? "text-sm text-muted-foreground" : "text-xs text-white/85"}`}>
        Fortalecimiento de las capacidades productivas de PYMES y organizaciones de base de los cantones de Buenos Aires, Coto Brus y Pérez Zeledón mediante el desarrollo endógeno
      </p>
    </div>
  </section>
);

export default ProjectCredits;
